import { LucideIcon, CpuIcon, ChartLineIcon } from 'lucide-react';

export type Module = {
  slug: string;
  title: string;
  description: string;
  icon: LucideIcon;
  href: string;
};

export const modules: Module[] = [
  {
    slug: 'scenario-analysis',
    icon: ChartLineIcon,
    title: 'Debt Scenario Analysis',
    description: 'Comprehensive debt sustainability analysis for U.S. States',
    href: '/modules/scenario-analysis',
  },
  {
    slug: 'stochastic-projection',
    icon: CpuIcon,
    title: 'Debt Stochastic Projection',
    description: 'Stochastic projections debt-to-GDP ratios for U.S. States',
    href: '/modules/stochastic-projection',
  }
];


